export const truncateString = (string: string, maxLength: number) => {
  if (string.length > maxLength) {
    return `${string.substring(0, maxLength)}...`;
  }
  return string;
};

export const firstLetterUppercase = (word: string) =>
  word[0].toUpperCase() + word.substring(1);

export const authorDescription = (name: string, description: string) => {
  if (!name && !description) return '';

  return `${name} - ${description}`;
};

export const handleNullableString = (char: string, property?: string) => {
  if (property?.length === 0) {
    return char;
  }

  return property ?? char;
};
